module.exports = __webpack_public_path__ + "static/media/chia-work-6.d97b59ad.jpg";